import {
  ROTA_CLINIC_GET_REQUEST,
  ROTA_CLINIC_GET_RESPONSE,
  ROTA_CLINIC_UPDATE,
  ROTA_CLINIC_DETAILS_GET_REQUEST,
  ROTA_CLINIC_DETAILS_GET_RESPONSE,
  ROTA_CLINIC_DETAILS_UPDATE,
  ROTA_CLINIC_GET_FAILURE
} from "../../actions/types";

const initialState = {
  isFetching: false,
  error: false,
  errMsg: "",
  clinics: [],
  selectedClinicCodes: [],
  selectedClinics: []

};

const setFetching = (state, action) => {
  let selectedClinicCodes =  action.payload.selectedClinicCodes || [];
  let selectedClinics = action.payload.selectedClinics || [];
  return {
    ...state,
    isFetching: true,
    clinics: [],
    selectedClinicCodes: selectedClinicCodes,
    selectedClinics: selectedClinics
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false
  };
};

const setResults = (state, action) => {
  let clinics = action.payload.clinics || [];

  return {
    ...state,
    isFetching: false,
    clinics
  };
};

const setUpdate = (state, action) => {
  let info = action.payload.info || {};
  let clinics = [...state.clinics]
  clinics.push(info)
  return {
    ...state,
    isFetching: false,
    clinics
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ROTA_CLINIC_GET_REQUEST:
      return setFetching(state, action);
      break;

    case ROTA_CLINIC_GET_RESPONSE:
      return setResults(state, action);
      break;

    case ROTA_CLINIC_GET_FAILURE:
      return setFailure(state);
      break;
    case ROTA_CLINIC_UPDATE:
      return setUpdate(state,action);
      break;

    case ROTA_CLINIC_DETAILS_GET_REQUEST:
      return setFetching(state, action);
      break;

    case ROTA_CLINIC_DETAILS_GET_RESPONSE:
      return setResults(state, action);
      break;

    case ROTA_CLINIC_DETAILS_UPDATE:
      return setFailure(state);
      break;
    case ROTA_CLINIC_UPDATE:
      return setUpdate(state,action);
        break;      

    default:
      return state;
      break;
  }
};
